import CalendarTimelineNodeV2 from './CalendarTimelineNodeV2';

import './CalendarTimelineNode.scss';

export default  CalendarTimelineNodeV2 ;